module.exports = __webpack_public_path__ + "img/digital_media.93d60faa.jpg";